/**
 * Collapsible list of prior uploads for a data-room item.
 * Renders nothing when there are no versions.
 */
import React, { useState } from 'react';

// Opens a stored file in a new tab. Same-origin "/..." paths are fetched with
// the auth cookie and shown via a blob URL; absolute URLs (S3 presigned, auth
// in the query string) are opened directly.
async function openFile(url) {
  if (!url) return;
  try {
    if (url.startsWith('/')) {
      // Same-origin API path (local storage) — needs credentials cookie
      const resp = await fetch(url, { credentials: 'include' });
      if (!resp.ok) return;
      const blob = await resp.blob();
      window.open(URL.createObjectURL(blob), '_blank', 'noopener');
    } else {
      // S3 presigned URL — auth is in the query string, open directly
      window.open(url, '_blank', 'noopener');
    }
  } catch {
    // file not accessible
  }
}

export default function VersionHistory({ versions }) {
  const [open, setOpen] = useState(false);

  if (!versions || versions.length === 0) return null;

  return (
    <div style={styles.wrapper}>
      <button style={styles.toggle} onClick={() => setOpen((v) => !v)}>
        {open ? '▲' : '▼'} {versions.length} version{versions.length !== 1 ? 's' : ''}
      </button>

      {open && (
        <ul style={styles.list}>
          {versions.map((v, i) => (
            <li key={v.url || i} style={styles.item}>
              <span style={styles.filename}>{v.name}</span>
              <span style={styles.date}>{v.uploadedAt}</span>
              <button
                style={styles.viewLink}
                onClick={() => openFile(v.url)}
              >
                View
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

const styles = {
  wrapper: {
    marginTop: 6,
    paddingLeft: 16,
  },
  toggle: {
    fontSize: 15,
    color: 'var(--color-forest)',
    opacity: 0.6,
    fontFamily: 'var(--font-body)',
    fontWeight: 600,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: '2px 0',
  },
  list: {
    listStyle: 'none',
    marginTop: 4,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 15,
    color: 'var(--color-forest)',
    opacity: 0.75,
  },
  filename: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  date: {
    flexShrink: 0,
    fontSize: 10,
  },
  viewLink: {
    flexShrink: 0,
    color: 'var(--color-rust)',
    fontWeight: 700,
    fontSize: 15,
    textDecoration: 'underline',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'var(--font-body)',
  },
};
